import { css } from '@/styled-system/css';

export const list = css({
  listStyle: 'none',
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
  padding: 0,
  margin: 0,
});

export const item = css({
  borderWidth: 'default',
  borderStyle: 'solid',
  borderColor: 'border.neutral',
  borderRadius: 'md',
  padding: 'default',
  background: 'bg.neutral',
});

export const dateText = css({
  color: 'text.neutral',
  fontSize: 'body',
  fontWeight: 'bold',
  lineHeight: 'body',
});

export const timeText = css({
  marginTop: 'tightest',
  color: 'text.neutral',
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
});

export const metaText = css({
  marginTop: 'tightest',
  color: 'text.subtle',
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
});

export const description = css({
  marginTop: 'tighter',
  color: 'text.subtle',
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
});
